import { ModuleModeEnum } from '@/enums/ModuleModeEnum';

export default {
    indicator: ({ values }: { values: { mode: ModuleModeEnum } }) => {
        const { mode } = values;
        return `请大声朗读标记的部分。
                    ${mode === ModuleModeEnum.SELF ? '点击文章可以移动段落。' : ''}`;
    },
    intro: {
        content: {
            loud: '请大声朗读标记的部分！',
            readingType1: '以{readingType}方式一起导读。',
            readingType2: '以{readingType}方式导读。',
            teacherAndStudents: '老师朗读黄色标记部分，学生朗读蓝色标记部分！',
            start: '以{readingType}方式开始导读吧？',
            students: '{students}同学请大声朗读标记的部分！',
        },
        othersCount: '等{count}人',
    },
    options: {
        title: '标题',
        readingType: { label: '阅读单位', unit: '单位', meaning: '意义', sentence: '句子', paragraph: '段落' },
        readingMode: {
            label: '阅读方式',
            all: '整体阅读',
            split: '分段阅读',
            random: '轮流阅读（随机）',
            selected: '轮流阅读（指定）',
        },
        example: { all: '全部一起', teacher: '老师', students: '学生' },
        textbook: '课本中的文章',
    },
    setting: {
        readerCount: '朗读学生人数',
        draw: '抽取',
        redraw: '重新抽取',
        resetSelection: '重置选择',
        randomOrderNotice: 'ⓘ 顺序将随机分配。',
        connectedCount: '在线{count}人',
        personCount: '{count}人',
        unit: '人',
    },
    inplay: {
        reading: '朗读中',
        readingCount: '{count}人',
        fontDown: 'A -',
        fontUp: 'A +',
        me: '我',
    },
    buttons: { next: '下一步学习', assign: '指定学生', assignStudents: '分配学生', fontSize: '字体大小' },
    result: {
        done: '导读已完成！',
        lecture: {
            all: '以"{readingType}单位""全体学生"进行了朗读。',
            split: '以"{readingType}单位"与"老师"分段朗读。',
            random: '以"{readingType}单位"{students}进行了朗读。',
            selected: '以"{readingType}单位"{students}进行了朗读。',
            averageTime: '耗时{time}',
        },
        self: {
            all: '以{readingType}方式全体学生进行了朗读。',
            split: '以{readingType}方式与老师分段朗读。',
            random: '以{readingType}方式{students}进行了朗读。',
            selected: '以{readingType}方式{students}进行了朗读。',
            averageTime: '平均耗时{time}',
            inplay: '正在以"{readingType}单位"进行"{readingMode}"。',
        },
    },
    teacherFooter: { done: '全部读完了。', click: '请点击文章区域。' },
    pageRange: '第{startPage}~{endPage}页',
};
